import { useNavigate, useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { v4 as uuidv4 } from "uuid";
import { CountryList } from "../../../data/holidays/CountryList";
export default function HolidaysYearsListData() {
  const navigate = useNavigate();
  const { countryName } = useParams<{ countryName: string }>();

  const years = countryName
    ? CountryList.find((item) => item.name === decodeURIComponent(countryName))
        ?.years || []
    : [];

  const oHandleClickHolidaysTable = (year: string) => {
    if (countryName) {
      navigate(
        `${process.env.PUBLIC_URL}/holidays/country/${encodeURIComponent(
          countryName
        )}/${year}`
      );
    }
  };

  return (
    <Row className="g-sm-4 g-3">
      {years.map((year) => (
        <Col xl="4" md="6" key={uuidv4()}>
          <div
            className="prooduct-details-box"
            onClick={() => oHandleClickHolidaysTable(year)}
            style={{ cursor: "pointer" }}
          >
            <div className="d-flex">
              <div className="flex-grow-1 ms-3">
                <div>
                  <div>{year}</div>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
}
